var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"className":"check-root"}},[_c('div',[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }